import React, { useState, useEffect } from "react";
import { IResourceComponentsProps } from "@refinedev/core";
import { Edit, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Select, Switch } from "antd";
import { IRegion, ITeam } from "interfaces";

export const StoreEdit: React.FC<IResourceComponentsProps> = () => {
  const [commissionType, setCommissionType] = useState<"percentage" | "amount">(
    "percentage"
  );
  const { formProps, saveButtonProps, queryResult, onFinish } = useForm();
  const storesData = queryResult?.data?.data;

  useEffect(() => {
    if (storesData?.commissionAmount != null) {
      setCommissionType("amount");
    }
  }, [storesData]);

  const { selectProps: regionSelectProps } = useSelect<IRegion>({
    resource: "regions",
    optionLabel: "name",
    optionValue: "id",
  });

  const { selectProps: teamsSelectProps } = useSelect<ITeam>({
    resource: "teams",
    optionLabel: "name",
    optionValue: "id",
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout='vertical'
        onFinish={(values: any) => {
          const result = {
            ...values,
            commissionType: commissionType,
            region: values.regionEdit,
            teams: values.teamsEdit.map((id: number) => ({ id })),
          };
          onFinish(result).catch((error) => error);
        }}
      >
        <Form.Item
          label='Id'
          name={["id"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input readOnly disabled />
        </Form.Item>
        <Form.Item
          label='Region'
          name='regionEdit'
          rules={[
            {
              required: true,
            },
          ]}
          initialValue={[storesData?.region?.id]}
        >
          <Select
            {...regionSelectProps}
            allowClear
            placeholder='Select Region'
          />
        </Form.Item>
        <Form.Item
          label='Name'
          name={["name"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Team(s)'
          name='teamsEdit'
          rules={[
            {
              required: true,
            },
          ]}
          initialValue={storesData?.teams?.map((item: ITeam) => item.id)}
        >
          <Select {...teamsSelectProps} allowClear mode='multiple' />
        </Form.Item>
        <Form.Item label='Commission Type' name='commission_type'>
          <Switch
            checked={commissionType !== "percentage"}
            onChange={(v) => {
              if (v) {
                setCommissionType("amount");
              } else {
                setCommissionType("percentage");
              }
            }}
          />
        </Form.Item>
      </Form>
    </Edit>
  );
};
